<script setup lang="ts">
import { RouterLink, type RouteLocationAsPathGeneric, type RouteLocationAsRelativeGeneric } from 'vue-router'

defineProps<{
  to: string | RouteLocationAsPathGeneric | RouteLocationAsRelativeGeneric
}>()
</script>

<template>
  <RouterLink :to="to" custom active v-slot="{ navigate, isActive }">
    <button class="side-menu-button" :class="{ 'is-active': isActive }" @click="navigate">
      <div class="icon">
        <slot name="icon"></slot>
      </div>
      <div class="label">
        <slot></slot>
      </div>
    </button>
  </RouterLink>
</template>

<style lang="scss" scoped>
.side-menu-button {
  border: none;
  display: flex;
  height: 40px;
  width: calc(100% - 6px);
  padding: 0;
  background-color: transparent;
  border-radius: 4px;
  margin-left: 3px;
  margin-right: 3px;

  &.is-active {
    background-color: var(--ullib-color-menu-active);
  }
  &:hover {
    background-color: var(--ullib-color-menu-hover);
  }
}

.icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 55px;
  max-width: 55px;
  height: 100%;
  flex-shrink: 0;
}

.label {
  display: flex;
  align-items: center;
  padding-left: 16px;
  color: var(--ullib-color-contrast);
  white-space: nowrap; //TODO - handle wrapping without weird opening
}
</style>
